var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBackgroundCheckBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H22C22.7956 4 23.5587 4.31607 24.1213 4.87868C24.6839 5.44129 25 6.20435 25 7V28C25 28.7956 24.6839 29.5587 24.1213 30.1213C23.5587 30.6839 22.7956 31 22 31H4C3.20435 31 2.44129 30.6839 1.87868 30.1213C1.31607 29.5587 1 28.7956 1 28V7C1 6.20435 1.31607 5.44129 1.87868 4.87868C2.44129 4.31607 3.20435 4 4 4H7",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H22C22.7956 4 23.5587 4.31607 24.1213 4.87868C24.6839 5.44129 25 6.20435 25 7V28C25 28.7956 24.6839 29.5587 24.1213 30.1213C23.5587 30.6839 22.7956 31 22 31H4C3.20435 31 2.44129 30.6839 1.87868 30.1213C1.31607 29.5587 1 28.7956 1 28V7C1 6.20435 1.31607 5.44129 1.87868 4.87868C2.44129 4.31607 3.20435 4 4 4H7",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5L8.5 23.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5L17.5 23.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1H8.5C7.67157 1 7 1.67157 7 2.5V5.5C7 6.32843 7.67157 7 8.5 7H17.5C18.3284 7 19 6.32843 19 5.5V2.5C19 1.67157 18.3284 1 17.5 1Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBackgroundCheckBadge);
export default __webpack_public_path__ + "static/media/no-background-check-badge.1bd4feeafc0b8dbc2a21bbb30aa3cf4b.svg";
export { ForwardRef as ReactComponent };